module.exports = __webpack_public_path__ + "img/questions.207ede3c.jpg";